"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_MESSAGE_BACK = void 0;
exports["default"] = sendMessageback;
var SEND_MESSAGE_BACK = 'WEB_CHAT/SEND_MESSAGE_BACK';
exports.SEND_MESSAGE_BACK = SEND_MESSAGE_BACK;

function sendMessageback(value, text, displayText) {
  return {
    type: SEND_MESSAGE_BACK,
    payload: {
      displayText: displayText,
      text: text,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX01FU1NBR0VfQkFDSyIsInNlbmRNZXNzYWdlYmFjayIsInZhbHVlIiwidGV4dCIsImRpc3BsYXlUZXh0IiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZW5kTWVzc2FnZUJhY2suanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9NRVNTQUdFX0JBQ0sgPSAnV0VCX0NIQVQvU0VORF9NRVNTQUdFX0JBQ0snO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kTWVzc2FnZWJhY2sodmFsdWUsIHRleHQsIGRpc3BsYXlUZXh0KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VORF9NRVNTQUdFX0JBQ0ssXG4gICAgcGF5bG9hZDogeyBkaXNwbGF5VGV4dCwgdGV4dCwgdmFsdWUgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX01FU1NBR0VfQkFDSyB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsaUJBQWlCLEdBQUcsNEJBQTFCOzs7QUFFZSxTQUFTQyxlQUFULENBQXlCQyxLQUF6QixFQUFnQ0MsSUFBaEMsRUFBc0NDLFdBQXRDLEVBQW1EO0VBQ2hFLE9BQU87SUFDTEMsSUFBSSxFQUFFTCxpQkFERDtJQUVMTSxPQUFPLEVBQUU7TUFBRUYsV0FBVyxFQUFYQSxXQUFGO01BQWVELElBQUksRUFBSkEsSUFBZjtNQUFxQkQsS0FBSyxFQUFMQTtJQUFyQjtFQUZKLENBQVA7QUFJRCJ9